import { z } from 'zod';

export const TestPathSchema = z.object({
  chainId: z.number({ coerce: true }), // Transform number string to number
});

export const TaskPathSchema = z.object({
  taskId: z.string(),
});

export const SportRecordDetailPathSchema = z.object({
  recordId: z.string(),
});
